import React from "react";
import "../Solution/Solution.scss";
import SectionHeadline from "../../../../UI/SectionHeadline/SectionHeadline";
import SectionUnderText from "../../../../UI/SectionUnderText/SectionUnderText";
import Translate from "react-translate-component";
import userAreaImage from "./../../../../../assets/images/userarea-app-image.png";
import homecareImage from "./../../../../../assets/images/caresee-app.png";
import assistentImage from "./../../../../../assets/images/assitent-area-image.png";
import wave from "./../../../../../assets/images/transition-orange.svg";
import AccordionQuestions from "./Accordion/Accordion";
import AccordionQuestionsWeb from "./Accordion/AccordionWeb";
import AccordionQuestionsAssistent from "./Accordion/AccordionQuestionsAssistent";
import ScrollAnimation from "react-animate-on-scroll";

export class Solution extends React.Component {
  constructor(props) {
    super(props);

    this.state = { image: "user_area" };
  }

  toggleButtons = (value) => {
    this.setState({ image: value });
  };
  render() {
    return (
      <section id={this.props.scrollAnchor} className="Solution">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 mb-2">
              <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
                <SectionHeadline className="dark">
                  <Translate content="homepage.solution.headline" />
                </SectionHeadline>
              </ScrollAnimation>
            </div>

            <div className="col-md-12">
              <SectionUnderText className="dark full-width">
                <Translate content="homepage.solution.text_1" unsafe={true} />{" "}
                <Translate content="homepage.solution.text_2" unsafe={true} />{" "}
                <Translate content="homepage.solution.text_3" unsafe={true} />
                <Translate content="homepage.solution.text_4" unsafe={true} />
              </SectionUnderText>
              <div className="toggle-buttons">
                <button
                  className={
                    this.state.image === "user_area" ? "is-active" : null
                  }
                  onClick={() => this.toggleButtons("user_area")}
                  style={{ lineHeight: "1rem" }}
                >
                  <Translate content="homepage.solution.tab_2"></Translate>
                </button>
                <button
                  className={
                    this.state.image === "homecare" ? "is-active" : null
                  }
                  onClick={() => this.toggleButtons("homecare")}
                >
                  <Translate content="homepage.solution.tab_1"></Translate>
                </button>
                <button
                  className={
                    this.state.image === "assistent" ? "is-active" : null
                  }
                  onClick={() => this.toggleButtons("assistent")}
                  style={{ lineHeight: "1rem" }}
                >
                  <Translate content="homepage.solution.tab_3"></Translate>
                </button>
              </div>
            </div>
            <div className="col-sm-12 col-lg-6">
              {this.state.image === "user_area" && <AccordionQuestionsWeb />}
              {this.state.image === "homecare" && <AccordionQuestions />}
              {this.state.image === "assistent" && (
                <AccordionQuestionsAssistent />
              )}
            </div>
            <div className="col-sm-12 col-lg-6">
              <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
                {this.state.image === "homecare" && (
                  <div className="d-flex justify-content-center justify-content-lg-end">
                    <img
                      src={homecareImage}
                      alt="homecare"
                      className="img-right"
                    />
                  </div>
                )}
                {this.state.image === "user_area" && (
                  <div className="d-flex justify-content-center justify-content-lg-end">
                    <img
                      src={userAreaImage}
                      alt="user-area"
                      className="img-right"
                    />
                  </div>
                )}
                {this.state.image === "assistent" && (
                  <div className="d-flex justify-content-center justify-content-lg-end">
                    <img
                      src={assistentImage}
                      alt="assistent"
                      className="img-right img-assistent"
                    />
                  </div>
                )}
              </ScrollAnimation>
            </div>
          </div>
        </div>
        <img src={wave} alt="wave-about" className="cs_wave" />
      </section>
    );
  }
}

export default Solution;
